<template>
    <b-alert :show="dismissCountDown"
             dismissible
             :variant="$store.state.notification_type"
             @dismissed="clear"
             @dismiss-count-down="countDownChanged">
        <p>{{ message }}</p>
    </b-alert>
</template>

<script>
    export default {
        data() {
            return {
                dismissSecs: 7,
                dismissCountDown: -1,
                showDismissibleAlert: false
            }
        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            clear() {
                this.$store.commit('clearNotification');
            }
        },
        watch: {
            dismissCountDown(){
                if(this.dismissCountDown === 0){
                    this.clear();
                }
            }
        },
        computed: {
            message() {
                this.showAlert();
                return this.$store.state.notification;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Alert/Notification.vue